"use client";

export default function EventsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  void error;
  return (
    <div className="min-h-[65vh] bg-warm-bg px-5 py-20 text-center">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-teal-dark">Public events</p>
      <h1 className="mt-3 font-serif text-4xl text-navy">The noticeboard is unavailable</h1>
      <p className="mx-auto mt-4 max-w-lg text-sm leading-6 text-text-muted">
        We could not load the public event notices. Try again in a moment.
      </p>
      <button
        type="button"
        onClick={reset}
        className="mt-7 inline-flex min-h-[44px] items-center justify-center rounded-full bg-navy px-6 py-2.5 text-sm font-bold text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal"
      >
        Try again
      </button>
    </div>
  );
}
